import { render } from "./SubscriptionsSkeleton.vue?vue&type=template&id=87ed4722&scoped=true&ts=true"
import script from "./SubscriptionsSkeleton.vue?vue&type=script&lang=ts"
export * from "./SubscriptionsSkeleton.vue?vue&type=script&lang=ts"

import "./SubscriptionsSkeleton.vue?vue&type=style&index=0&id=87ed4722&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ed4722"]])

export default __exports__